export default __webpack_public_path__ + "static/EmbuGuacu-788da57ec2ffa6b936553154af824d5f.svg";